import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import axios_instance from './api/index'
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies'
import Antd from 'ant-design-vue'
import { message } from 'ant-design-vue'

import './plugins/bootstrap-vue'
import './library/date'

import 'element-ui/lib/theme-chalk/index.css'
import 'ant-design-vue/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import global_define from './library/global/define'
Vue.config.productionTip = global_define.debug == false

Vue.use(require('vue-script2'))

Vue.prototype.$axios = axios
Vue.prototype.instance = axios_instance // axios实例

Vue.use(VueCookies)
Vue.$cookies.config('7d', { sameSite: '' })
Vue.use(Antd)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(ElementUI)
import VueSignature from 'vue-signature-simple'
Vue.use(VueSignature)

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
    // 定义组件中的数据对象
    keyName: 'head',
});
Vue.prototype.$message = message
message.config({
    top: `20px`,
    duration: 2,
    maxCount: 1,
});

import urls from "./api/urls"
router.beforeEach((from, to, next) => {
    //如果地址中包含code(微信扫码后返回用于换取用户信息的临时票据)，则拦截并执行登录逻辑
    if (window.location.href.indexOf('code') >= 0) {
        //如果url中包含code,则保存到store中
        let code = window.location.href.split("?")[1];
        code = code.substring(5, code.indexOf('&'));
        if (code != null && "" != code && code != undefined) {
            //向后台登录接口发送数据
            axios_instance.post(urls.wechat.redirect_feedback, {
                'code': code
            }).then((r) => {
                //后端成功返回token则视为登录成功
                console.log(r)
                if (r && r.code == 2) {
                    next('UserBind');
                } else {
                    next("OrderList")
                }
            })
        }
    } else {
        next()
    }

})

new Vue({
    el: '#app',
    router,
    render: h => h(App)
})